import React from 'react'
import { LoadingIndicator } from './LoadingIndicator'

export const LoadingBackdrop = () => {
    return (
        <div className={"fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50"}>
            <LoadingIndicator />
        </div>
    )
}